import { useCallback, useMemo, useState } from 'react';
import { StreamType, UpdateBroadcast, UpsertBroadcastCustomerRestriction } from 'videoservice-openapi-react';
import { TUpdatePayload } from '../../ui';

export const useManualBroadcastState = () => {
  const [title, setTitle] = useState<string>();
  const [streamType, setStreamType] = useState<StreamType>();
  const [streamUrl, setStreamUrl] = useState<string>();
  const [sportId, setSportId] = useState<number>();
  const [startDate, setStartDate] = useState<Date>();
  const [restrictedPlatformIds, setRestrictedPlatformIds] = useState<number[]>();
  const [restrictedGeozoneIds, setRestrictedGeozoneIds] = useState<number[]>();

  const newBroadcastData = useMemo<UpdateBroadcast>(() => ({
    sportId,
    startDate,
    streamType,
    title,
    url: streamUrl,
  }), [sportId, startDate, streamType, streamUrl, title]);

  const newBroadcastRestrictionsData = useMemo<UpsertBroadcastCustomerRestriction>(() => ({
    geozoneIds: restrictedGeozoneIds,
    platformIds: restrictedPlatformIds,
  }), [restrictedGeozoneIds, restrictedPlatformIds]);

  const changeHandler = useCallback((payload: TUpdatePayload) => {
    setTitle(payload.title);
    setStreamType(payload.streamType);
    setStreamUrl(payload.url);
    setSportId(payload.sportId);
    setStartDate(payload.startDate);
    setRestrictedPlatformIds(payload.platformIds);
    setRestrictedGeozoneIds(payload.geozoneIds);
  }, []);

  return {
    newBroadcastData,
    newBroadcastRestrictionsData,
    changeHandler,
  };
};
